import React, { useEffect, useState } from 'react';
import {
    DialogContent,
    Dialog,
    DialogActions,
    DialogTitle,
    Button,
} from '@material-ui/core'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import Alert from '@material-ui/lab/Alert';

import { getActivityHistoryByMemberId } from '../../../../actions/activity-actions';
import useStyles from '../../../../styles/components/rewards/stylesRewardShop';

const ViewActivityHistory = ({ _studentNumber, _memberId, _handleClose }) => {

    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(true);
    const [history, setHistory] = useState([]);

    useEffect(() => {
        initActivityHistory();
    }, []);

    const initActivityHistory = async () => {
        let response = await getActivityHistoryByMemberId(_memberId);
        setIsLoading(false);
        if (response > 200 || response.status === "Failed") {
            setHistory([])
        }
        if (response.status === "Success") {
            let history = response.data.map((item) => {
                item.TimeTaken = secondsToHms(item.TimeTaken);
            });

            //console.log("History", history)
            setHistory(response.data)
        }
    };

    function secondsToHms(d) {
        d = Number(d);
        let h = Math.floor(d / 3600);
        let m = Math.floor(d % 3600 / 60);
        let s = Math.floor(d % 3600 % 60);

        let hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
        let mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
        let sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
        let time = hDisplay + mDisplay + sDisplay;
        time = time.length > 0 ? time : "NA"
        return time;
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth='md'
            open={true}
            classes={{
                root: classes.rootDialogConfirm,
                paper: classes.paperDialogConfirm,
            }}
        >
            <DialogTitle disableTypography={true} style={{ fontSize: '20px' }} classes={{ root: classes.rootDialogConfirmTitle }}>
                Activity History of {_studentNumber}
            </DialogTitle>

            {
                isLoading ?
                    <Alert style={{ margin: "10px" }} variant="outlined" severity="info">
                        Please wait for a while...
                    </Alert>
                    :
                    <>
                        <DialogContent classes={{ root: classes.rootDialogConfirmContent }}>
                            {
                                history.length > 0 ?
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow style={{ backgroundColor: '#0492C2' }}>
                                                    <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Activity Title</TableCell>
                                                    <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Is Completed</TableCell>
                                                    <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Time Taken</TableCell>
                                                    <TableCell align="center" style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>Score</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {history.map((row) => (
                                                    <TableRow key={row.ActivityId}>
                                                        <TableCell align="center">{row.ActivityTitle}</TableCell>
                                                        <TableCell align="center">{row.IsCompleted ? "Yes" : "No"}</TableCell>
                                                        <TableCell align="center">{row.TimeTaken}</TableCell>
                                                        <TableCell align="center">{row.Score}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    :
                                    <>No data</>
                            }
                        </DialogContent>
                        <DialogActions classes={{ root: classes.rootDialogActions }}>
                            <Button onClick={_handleClose} className={clsx(classes.buttonDialogConfirm, classes.buttonYes)}>
                                Ok
                            </Button>
                        </DialogActions>
                    </>
            }
        </Dialog>
    );
};

export default ViewActivityHistory;
